import {reactive, toRefs, computed, provide, inject} from "@vue/composition-api";
import Vue from "vue";
import axios from "axios";
import ApiProduct from '@/api/product/product'
import {updateListState} from "../store_helpers";

export const state = reactive({
    map: new Map(),
    list: [],
    products_loading: false
});

export const actions = {

    async fetchProduct(product_id) {
        let response;
        response = await ApiProduct.getProduct(product_id);
        updateListState(response.id, response, state.list);
        return response;
    },

    saveProduct(data, update_contracts_and_invoices = 0) {
        let product_id = data && data.id ? data.id : 0
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/products/{0}?update_contracts_and_invoices={1}".format(product_id, update_contracts_and_invoices), data)
                .then(function (resp) {
                    updateListState(product_id, resp.data, state.list, "id", true);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },

    // todo :: fixme :: test if this works correctly
    deleteProduct(product_id, raise_error) {
        return new Promise(function (resolve, reject) {
            let params = {
                raise_error: raise_error
            }
            axios
                .delete(Vue.config.url_prefix + "/api/products/{0}".format(product_id), {params: params})
                .then(function (resp) {
                    updateListState(product_id, null, state.list);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },

    // todo :: fixme :: get all products (do we support NULL products ???)
    async fetchProducts(company_id) {
        state.products_loading = true
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/products/", {params: {company_id: company_id}})
                .then(resp => {
                    state.list = resp.data;
                    resolve(resp.data);
                })
                .catch(ex => reject(ex))
                .finally(() => {
                    state.products_loading = false
                })
        });
    },
};

export const getters = {
    products: computed(() => state.list)
};

export const key = Symbol("ProductModule");

export const provideProduct = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
